import { CustomDateFormatPipe } from '../../../../_helpers/_pipes/custom-date-format.pipe';
import { SortBillsByDate } from '../../../../_helpers/_pipes/sortdate.pipe';
import { CalendarMonoColorSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/calendar-mono-color-svg/calendar-mono-color-svg.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { PdfDocumentSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/pdf-document-svg/pdf-document-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService, AlertService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PaperlessService } from '@services/_iam/paperless.service';
import { DocumentsDataService } from '@services/data-services/documents-data.service';
import { EventService } from '@services/event-service.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, PdfDocumentSvgComponent, MapfreModalComponent, CalendarMonoColorSvgComponent, SortBillsByDate, CustomDateFormatPipe],
  selector: 'app-bn-as-fourhundred-policy',
  templateUrl: './bn-as-fourhundred-policy.component.html',
  styleUrls: ['./bn-as-fourhundred-policy.component.scss']
})
export class BnAsFourhundredPolicyComponent implements OnInit {
  @Input() policy: any;
  scheduledBills: any;
  multiplePaymentModal: ModalOptions;
  downloadInvoice: any;
  schedualOrHistory: any;
  billingHistory: any;

  hideModalOnRoute: any = false;
  showMessage: boolean;
  isAcmic: boolean;
  policyId: string;
  constructor(
    private documentsDataService: DocumentsDataService,
    private eventService: EventService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private alertService: AlertService,
    private acmicService: AcmicService) {
    this.isAcmic = this.acmicService.isACMIC();
    this.schedualOrHistory = true;
  }

  onDownloadDocument(documentId) {
    this.documentsDataService.getPolicyDocumentData(
      this.policyId,
      documentId,
      'Invoice_' + this.policyId,
      false
    );
  }
  closeModal() {
    this.showMessage = false;
  }

  onShowMessage() {
    this.showMessage = true;
    this.hideModalOnRoute = true;
  }
  hideModal() {
    this.hideModalOnRoute = false;
  }
  resetHideModal() {
    this.hideModalOnRoute = !this.hideModalOnRoute;
  }
  switchHistories(type): void {
    if (type == 'schedual') {
      this.schedualOrHistory = true;
    } else {
      this.schedualOrHistory = false;
    }
  }
  getDataForAS400() {
    this.billingHistory =
      this.policy &&
        this.policy.historyBills &&
        this.policy.historyBills.length > 0
        ? this.policy.historyBills
        : null;
    this.scheduledBills =
      this.policy &&
        this.policy.scheduleBills &&
        this.policy.scheduleBills.length > 0
        ? this.policy.scheduleBills
        : null;

    if (this.scheduledBills) {
      this.scheduledBills.forEach((scheduledBill) => {
        if (
          scheduledBill.invoiceState.toLowerCase() == 'due' ||
          scheduledBill.invoiceState.toLowerCase() == 'billed'
        ) {
          this.downloadInvoice = true;
        } else {
          this.downloadInvoice = false;
        }
      });
    }
  }
  setMultiplePaymentModalOptions() {
    this.multiplePaymentModal = new ModalOptions({
      additionalButtonClasses: 'multiple-link2 p-0',
      additionalClasses: 'modal-medium modal-dialog center-on-page',
      buttonCopy: null,
      modalId: '12311',
      modalTranslateCopy: 'Payment details',
      size: 'modal-medium',
      typeOfModal: 'default',
      modalName: 'billing_Multiple_Pay_Now',
    });
  }

  resetData() {
    this.getDataForAS400();
    this.setMultiplePaymentModalOptions();
    this.policyId = this.policy.policynumber.policyNumber;
  }
  viewEBILL() {
    const email = this.storageServiceObservablesService.getUserFromStorage();
    this.paperlessService.viewEBILL(email).subscribe(
      (response) => {
        this.documentsDataService.kubraLoginRequest(response);
      },
      () => {
        this.alertService.error('PROBLEM_IN_REQUEST_PROCESSING');
        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
      }
    );
  }

  ngOnInit(): void {
    this.resetData();
    this.eventService.childEventListner().subscribe(data => {
      if (data?.key === 'initiallize-overview-comp') {
        this.policy = data?.policy;
        this.resetData();
      }
    })
  }

}
